import IAbilityOrigin from './IAbilityOrigin'
import IMetric from './IMeasuredMetric'
import ISpecCategory from './ISpecCategory'
import ISuitableActivity from './ISuitableActivity'

export enum Ability {
  math = 'math',
  attention = 'attention',
  memory = 'memory',
  spatial = 'spatial',
  selfEsteem = 'self-esteem',
  motor = 'motor',
  executiveFunctions = 'executive_functions',
  social = 'social',
  language = 'language'
}

export const abilityKeys = [
  Ability.math,
  Ability.attention,
  Ability.memory,
  Ability.spatial,
  Ability.selfEsteem,
  Ability.motor,
  Ability.executiveFunctions,
  Ability.social,
  Ability.language
]

export type Abilities<T> = { [key in Ability]: T }

interface IAbilityData {
  key: Ability
  label: string
  description?: string
  metrics: IMetric[]
  suitableActivities: ISuitableActivity[]
  relevantSpecialists: ISpecCategory[]
  origin: IAbilityOrigin
}

export default IAbilityData



// WEBPACK FOOTER //
// ./src/data/abitilies/interfaces/IAbilityData.ts